
import React, { useEffect, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import Conexao from '../../../../providers/Conexao';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { Knob } from 'primereact/knob';
import { Tag } from 'primereact/tag';
import { ProgressBar } from 'primereact/progressbar';
import fontConfig from '../../../../Componentes/FontConfig';
import ConexaoInventory from '../../../../providers/ConexaoInventory'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


export default function SidebarInventory(props) {
  
    const [detalhesDca, setDetalhesDca] = useState([])
    const [openSidebar, setOpenSidebar]= useState(false)

  



    const  renderClasse = (horasRestantes, ativo) => {

               
           // console.log("Data is not an array or is undefined.");
            if(horasRestantes > 5 ){
    
                return  <Tag severity="danger" icon="pi pi-ban" style={{cursor:'pointer'}} onClick={()=>{
                    if(ativo !=='t' ){
                        return
                    }
                    getOne();
                    setOpenSidebar(true)
                }}></Tag>
    
            }else if(horasRestantes > 1 && horasRestantes <=5){
    
                return <Tag severity="warning" icon="pi pi-minus-circle" style={{cursor:'pointer'}} onClick={()=>{
                  
                    getOne();
                    setOpenSidebar(true)
                }}></Tag>
                
            } else{
    
                return <Tag severity="success" icon="pi pi-check-circle" style={{cursor:'pointer'}} onClick={()=>{
                    getOne();
                    setOpenSidebar(true)
                }}></Tag>
    
            }   
        }

    const getOne = () =>{

        ConexaoInventory.get('InventoryController/getOne?id='+props.id).then(response=>{
            if(response.status == 200 && response.data.status === 'OK'){
                setDetalhesDca(response.data.payload[0])
            }else{
                setDetalhesDca([])
            }
        }).catch(error =>{
            setDetalhesDca([])
        })
    }



        const customHeader = (
            <div className="flex align-items-center gap-2"> 
             
                <span className="font-bold text-xl" style={{marginLeft : '10px'}}><Tag severity="contrast" value={detalhesDca.Bios?.SerialNumber}></Tag> {detalhesDca.Modelo?.Model}</span>
                {
                    detalhesDca.coletaAtiva === 't' ?
                    <Tag severity='success' value ='ATIVO'></Tag>
                    :
                    <Tag severity='danger' value ='INATIVO'></Tag>
                }
    
     
    
                {
                    props.dias === 0 ?
                    <Tag severity='success' value ='ONLINE'></Tag>
                    :
                    <Tag severity='danger' value ='OFFLINE'></Tag>
                }
    
                            
    
            </div>
        );

 const bytesToGigabytes = (bytes) =>{
        const gigabytes = bytes / (1024 ** 3);
        return gigabytes.toFixed(2); // Arredonda para 2 casas decimais
    }

   /*
    <Knob value={value} onChange={(e) => setValue(e.value)} valueTemplate={'{value}%'} />
    <ProgressBar value={value}></ProgressBar>
    */
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
     const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top'
            },
            title: {
                display: true,
                text: 'Carga de CPU e Memória'
            }
        },
         scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
    };

    const chartData = {
        labels: detalhesDca.dataLog && detalhesDca.dataLog.map((_, index) => `Log #${index + 1}`),
        datasets: [
            {
                label: 'CPU (%)',
                data: detalhesDca.dataLog && detalhesDca.dataLog.map(log => log.cargaProcessador),
                fill: true,
                borderColor: '#42A5F5',
                tension: 0.4, 
                backgroundColor: 'rgba(10, 53, 196, 0.1)',
                pointBackgroundColor: detalhesDca.dataLog && detalhesDca.dataLog.map(log => log.cargaProcessador > 70 ? 'red' : '#42A5F5'),
                pointBorderColor: detalhesDca.dataLog && detalhesDca.dataLog.map(log => log.cargaProcessador > 70 ? 'red' : '#42A5F5')
            },
            {
                label: 'Memória (%)',
                data: detalhesDca.dataLog && detalhesDca.dataLog.map(log => log.cargaMemoria),
                fill: true,
                borderColor: '#66BB6A',
                tension: 0.4, 
                backgroundColor: 'rgba(8, 97, 45, 0.1)', 
                pointBackgroundColor: detalhesDca.dataLog && detalhesDca.dataLog.map(log => log.cargaMemoria > 70 ? 'red' : '#42A5F5'),
                pointBorderColor: detalhesDca.dataLog && detalhesDca.dataLog.map(log => log.cargaMemoria > 70 ? 'red' : '#42A5F5')
            }
        ]
    };

     const renderData = (data) =>{
        var teste = data.split('T')
        return teste[0]+' '+teste[1].substr(0,8)
    }


    return (
        <div className="card sidebar-silver" >
            {
                renderClasse(props?.dias, props?.ativo)
            }
                                          
            <Sidebar style={{width : '60vw',  }} header={customHeader} visible={openSidebar} position="right" onHide={() => setOpenSidebar(false)}>  
                <Divider style={{marginTop : '10px'}}/>              
                <div className="flex flex-wrap gap-0">
                    <div className="col-12 md:col-4">
                        <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>ID</label><br/>
                        <InputText value={detalhesDca.chaveDca}  className="w-full mt-2"/>
                        
                    </div>
                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Chave DCA</label><br/>
                        <InputText value={detalhesDca.chaveDca}  className="w-full mt-2"/>                    
                    </div>
                    <div className="col-12 md:col-5">
                        <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Razão Social</label><br/>
                        <InputText value={detalhesDca.razaoSocial}  className="w-full mt-2"/>
                    </div>
             </div>
             <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-3">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Domain Name</label><br/>
                  
                    <InputText value={detalhesDca.domainName}  className="w-full mt-2"/>
                </div>
                
                <div className="col-12 md:col-3">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold', fontWeight:'bold'}}>User Name</label><br/>
                     <InputText value={detalhesDca.userName}  className="w-full mt-2"/>
                    
                </div>
                
                <div className="col-12 md:col-3">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Host Name</label><br/>                    
                     <InputText value={detalhesDca.hostName}  className="w-full mt-2"/>
                </div>

                <div className="col-12 md:col-3">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Tipo dispositivo</label><br/>
                    
                     <InputText value={detalhesDca.typeDevice}  className="w-full mt-2"/> 
                </div>
                   
              </div>

              <Divider/>
              
               <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-2">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Modelo</label><br/>                    
                     <InputText value={detalhesDca.Modelo?.Model}  className="w-full mt-2"/>
                </div>
                
                <div className="col-12 md:col-3">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold', fontWeight:'bold'}}>Fabricante</label><br/>                    
                    <InputText value={detalhesDca.Modelo?.Manufacturer}  className="w-full mt-2"/>
                </div>
                
                <div className="col-12 md:col-2">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Versão Bios</label><br/>                    
                    <InputText value={detalhesDca.Bios?.Version}  className="w-full mt-2"/>
                </div>
                <div className="col-12 md:col-5">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Número série</label><br/>
                   
                    <InputText value={detalhesDca.Bios?.SerialNumber}  className="w-full mt-2"/> 
                </div>

                <div className="col-12 md:col-3">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Número série alternativo</label><br/>
                   
                    <InputText value={detalhesDca.numeroSerieAlternativo}  className="w-full mt-2"/> 
                </div>
                <div className="col-12 md:col-1">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>PAT</label><br/>
                    
                    <InputText value={detalhesDca.Patrimonio}  className="w-full mt-2"/>
                </div>
                <div className="col-12 md:col-2">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Data 1º Leitura</label><br/>
                    
                    <InputText value={detalhesDca.dataCadastro && renderData(detalhesDca.dataCadastro)}  className="w-full mt-2"/>
                </div>
                <div className="col-12 md:col-2">
                    <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Data Atualização</label><br/>
                    
                    <InputText value={detalhesDca.dataCadastro && renderData(detalhesDca.dataAtualizacao)}  className="w-full mt-2"/>
                </div>
                <div className="col-12 md:col-3 pt-5">

                    <Button disabled={props.loading} severity="secondary" className="mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                            confirmDialog({
                            message: 'Deseja Gravar?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {}
                        });
                    }} />
       

               
                    <Button disabled={props.loading} severity="primary" className="mr-2" label="Gravar" icon="pi pi-times" onClick={() => {
                            confirmDialog({
                            message: 'Deseja Gravar?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {}
                        });
                    }} />


                </div>
              </div>
               <Chart type="line" data={chartData} options={chartOptions}   />
              <TabView style={{marginTop : '20px'}} tabIndex={0}>
                                 
                    <TabPanel header="Processador" leftIcon="pi pi-microchip text-2xl mr-2"  tabIndex={1}>
                                <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>Percentual de uso do processador</label><br/>
                                <ProgressBar 
                                    className="custom-progress"  
                                    style={{ height: '16px', marginTop:'5px' }} 
                                    value={Math.round(detalhesDca.usoProcessador)}></ProgressBar><br/>
                                <DataTable
                                    value={detalhesDca.Processors}
                                    paginator 
                                    totalRecords={detalhesDca.Processors?.length}             
                                    rows={25} // Número de itens por página
                                    rowsPerPageOptions={[10, 15, 20, 25,50]} // Opções de páginas
                                    responsiveLayout="scroll"
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                    tableStyle={{ minWidth: '35rem' }}>
                                        <Column bodyStyle={{ fontSize: fontConfig.small , width : '50%', paddingTop : '2px', paddingBottom : '2px' }} 
                                            headerStyle={{ fontSize: fontConfig.small }} 
                                            header='Modelo'
                                            field='Name'/>
                                            
                                        <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                            headerStyle={{ fontSize: fontConfig.small }} 
                                            header='Núcleos'
                                            field='NumberOfCores'/>
                                        
                                        <Column bodyStyle={{ fontSize: fontConfig.small , width : '30%', paddingTop : '2px', paddingBottom : '2px' }} 
                                            headerStyle={{ fontSize: fontConfig.small }} 
                                            header='Nº Série'
                                            field='ProcessorId'/>

                                        <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                            headerStyle={{ fontSize: fontConfig.small }} 
                                            header='Clock'
                                            field='MaxClockSpeed'/>
                                </DataTable>                                             
                    </TabPanel>
                  
                    <TabPanel header="Memória" leftIcon="pi pi-microchip-ai text-2xl mr-2"  tabIndex={2}>
                            <label htmlFor="inscEstadual" style={{fontSize : '0.7rem', fontWeight:'bold'}}>% uso memória</label><br/>
                            <ProgressBar 
                                className="custom-progress" 
                                style={{ height: '16px', marginTop:'5px' }} 
                                height={16} value={Math.round(detalhesDca.usoMemoria)}></ProgressBar><br/>
                            <DataTable
                                value={detalhesDca.Memory}
                                paginator 
                                totalRecords={detalhesDca.Memory?.length}             
                                rows={25} // Número de itens por página
                                rowsPerPageOptions={[10, 15, 20, 25,50]} // Opções de páginas
                                responsiveLayout="scroll"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                tableStyle={{ minWidth: '35rem' }}>
                                    <Column bodyStyle={{ fontSize: fontConfig.small , width : '50%', paddingTop : '2px', paddingBottom : '2px' }} 
                                        headerStyle={{ fontSize: fontConfig.small }} 
                                        header='Fabricante'
                                        field='Manufacturer'/>
                                        
                                    <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                        headerStyle={{ fontSize: fontConfig.small }} 
                                        header='Capacidade'
                                        field='Capacity'/>
                                    
                                    <Column bodyStyle={{ fontSize: fontConfig.small , width : '30%', paddingTop : '2px', paddingBottom : '2px' }} 
                                        headerStyle={{ fontSize: fontConfig.small }} 
                                        header='Part Number'
                                        field='PartNumber'/>

                                    <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                        headerStyle={{ fontSize: fontConfig.small }} 
                                        header='Clock'
                                        field='Speed'/>
                            </DataTable>
              
                    </TabPanel>
                    <TabPanel header="Discos" leftIcon="pi pi-save text-2xl mr-2"  tabIndex={3}>
                        <div>
                   {
                        detalhesDca.Discos && detalhesDca.Discos.map(function(disco, i){
                            return <React.Fragment><div style={{width :'100%', marginTop : '10px'}}>
                                <span variant='subtitle2'>{disco.Model}</span><br/>
                                <span variant='caption' style={{marginTop : '10px', paddingTop : '5px', fontSize: '0.7rem'}}>Size: {bytesToGigabytes(disco.Size)}GB(s)</span>
                                {
                                    disco.Partitions && disco.Partitions.map(function(particao, i){
                                        return particao && particao.LogicalDisks.length  > 0 ? <div style={{marginTop :'3px'}}>
                                            <span variant='caption' style={{marginTop : '10px', paddingTop : '5px', fontSize: '0.9rem'}}>Partições:</span>
                                            {
                                                particao.LogicalDisks && particao.LogicalDisks.filter(logico => logico.DeviceID != null).map(function(unidade, i){
                                                    return unidade ? <div>
                                                        <span variant='caption' style={{marginTop : '10px', paddingTop : '5px', fontSize: '0.7rem'}}>Unidade : {unidade.DeviceID}</span><br/>
                                                        <span variant='caption' style={{marginTop : '10px', paddingTop : '5px', fontSize: '0.7rem'}}>Capacidade : {bytesToGigabytes(unidade.Size)}</span><br/>
                                                        <span variant='caption' style={{marginTop : '10px', paddingTop : '5px', fontSize: '0.7rem'}}>Livre : {bytesToGigabytes(unidade.FreeSpace)}</span><br/>
                                                        <ProgressBar value={Math.floor((unidade.FreeSpace / unidade.Size) *100)} variant='determinate' style ={{height : '15px', marginTop: '10px'}}/>
                                                        <span variant='caption' style={{marginTop : '10px', paddingTop : '5px', fontSize: '0.7rem'}}>{Math.floor((unidade.FreeSpace / unidade.Size) *100)}% Livre</span>
                                                        </div> : null
                                                })
                                            }

                                        </div> : null
                                    })
                                }
                       
                            </div>
                            <Divider style ={{marginTop : '5px'}}/>
                            </React.Fragment>
                        })
                    }
                   </div>

                    </TabPanel>
                    <TabPanel header="Video" leftIcon="pi pi-window-maximize text-2xl mr-2"  tabIndex={4}>
                        <DataTable
                            value={detalhesDca.VideoAdapters}
                            paginator 
                            totalRecords={detalhesDca.VideoAdapters?.length}             
                            rows={25} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25,50]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem' }}>
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '30%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Nome'
                                    field='Description'/>
                                    
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '25%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Processador Video'
                                    field='VideoProcessor'/>
                                
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Tipo'
                                    field='Tipo'/>
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '25%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Memória'
                                    field='VideoMemorySize'/>

                              
                        </DataTable>

                        <label htmlFor="inscEstadual" style={{fontSize : '0.9rem', fontWeight:'bold', marginTop : '10px'}}>Monitores</label><br/>
                        <DataTable
                            style={{marginTop : '10px'}}
                            value={detalhesDca.Monitors}
                            paginator 
                            totalRecords={detalhesDca.Monitors?.length}             
                            rows={25} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25,50]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem' }}>
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '30%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Nome'
                                    field='Name'/>
                                    
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '25%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='ScreenWidth'
                                    field='ScreenWidth'/>
                                
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='ScreenHeight'
                                    field='ScreenHeight'/>
                         

                              
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Rede" leftIcon="pi pi-globe text-2xl mr-2"  tabIndex={5}>
                        <DataTable
                            value={detalhesDca.NetworkAdapters}
                            paginator 
                            totalRecords={detalhesDca.NetworkAdapters?.length}             
                            rows={25} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25,50]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem' }}>
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '50%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Nome'
                                    field='Description'/>
                                    
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='MACAddress'
                                    field='MACAddress'/>
                                
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '5%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Tipo'
                                    field='Tipo'/>
                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '25%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Endereço IP'
                                    field='IPAddresses'/>

                                <Column bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header='Status'
                                    field='Status'/>
                        </DataTable>
                    </TabPanel>

              </TabView>
            </Sidebar>

        </div>
    )
}
        